import styled from 'styled-components';
import { breakpoints } from '@vfit/shared/themes';

export const MultiSelectionFilterContainer = styled.div`
  margin: 0 25px;

  @media (min-width: ${breakpoints.bigDesktop}) {
    margin: 0 80px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0 40px;
  align-self: stretch;

  input {
    border-radius: 30px;
    width: 100%;
  }

  @media (min-width: ${breakpoints.bigDesktop}) {
    flex-flow: row wrap;
    gap: 20px;
    align-items: baseline;
    justify-content: center;
  }
`;

export const SelectInput = styled.div`
  flex-grow: 2;
`;

export const SearchButton = styled.div`
  .capitalize-first {
    text-transform: lowercase;
  }

  .capitalize-first::first-letter {
    text-transform: uppercase;
  }

  a {
    text-decoration: unset;
  }

  button {
    padding: 13px 15px;
  }

  @media (min-width: ${breakpoints.tablet}) {
    margin: auto;

    button {
      width: 280px;
    }
  }

  @media (min-width: ${breakpoints.bigDesktop}) {
    margin: unset;

    button {
      width: 200px;
    }
  }
`;

